import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import { generateListTags } from 'utils/helpers/fetch';
import * as R from 'ramda';

import { CURRENT_LOCATION_ID } from './terminalLocatorConstants';

const getUrl = R.concat('terminal-locator/');

const terminalLocatorEndpoints = loadingManagementApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getAdditives: query({
      providesTags: generateListTags('Additive', 'id'),
      query: () => ({
        url: getUrl('get-additives'),
      }),
      transformResponse: response => response.map((additive, id) => ({ id, ...additive })),
    }),
    getBaseProducts: query({
      providesTags: generateListTags('BaseProduct', 'productId'),
      query: () => ({
        url: getUrl('get-base-products'),
      }),
    }),
    getLocatorTerminals: query({
      providesTags: generateListTags('Terminal', 'terminalId'),
      query: () => ({
        url: getUrl('get-terminals'),
      }),
    }),
    getTerminalCities: query({
      providesTags: generateListTags('City', 'id'),
      query: () => ({
        url: getUrl('get-terminal-cities'),
      }),
      transformResponse: response => [
        { city: 'Current Location', id: CURRENT_LOCATION_ID, label: 'Current Location' },
        ...response.map((city, id) => ({ id, label: `${city.city}, ${city.state}`, ...city })),
      ],
    }),
  }),
});

/* eslint-disable import/prefer-default-export */
export const {
  useGetAdditivesQuery,
  useGetBaseProductsQuery,
  useGetLocatorTerminalsQuery,
  useGetTerminalCitiesQuery,
} = terminalLocatorEndpoints;
